import React from 'react';

export default function Header() {
    return (
        <div className="header bg-danger py-6">
            <div className="container-fluid">
                <div className="header-body">
                    <div className="row align-items-center py-4">
                        <div className="col-lg-6 col-7">
                            <h6 className="h2 text-white d-inline-block mb-0">Extrato</h6>
                        </div>
                        <div className="col-lg-6 col-5 text-right">
                            <a href="#" className="btn btn-sm btn-neutral">Filtros</a>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/Header.js